import { render, staticRenderFns } from "./quem-somos.vue?vue&type=template&id=cec7fa90&"
import script from "./quem-somos.vue?vue&type=script&lang=js&"
export * from "./quem-somos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports